import React from "react"
//import I18n from "i18n-js/index.js.erb"
import clsx from "clsx"

class EditorToolbar extends React.Component {

  constructor(props) {
    super(props);
    this._onToggleDropdown = this._onToggleDropdown.bind(this);
  }

  componentDidUpdate() {
    setTimeout(this.positionTooltips, 0);
  }

  render() {
    var props = {
      rowId: this.props.rowId,
      columnId: this.props.columnId,
      initialStyle: this.props.initialStyle,
      onStyleChange: this.props.onStyleChange
    };

    var buttons = [
      {
        name: PageBuilderConstants.SAVE,
        tooltip: I18n.t('save_changes'),
        html: I18n.t('save'),
        onClick: this.props.onSave,
        className: 'btn-primary'
      },
      {
        name: PageBuilderConstants.CANCEL,
        tooltip: I18n.t('discard_changes'),
        html: I18n.t('cancel'),
        onClick: this.props.onCancel
      },
      {
        name: PageBuilderConstants.BACKGROUND_COLOR,
        tooltip: I18n.t('background_color'),
        html: '<span class="ss-palette"></span>',
        components: <BackgroundColorDropdown {...props} ref={PageBuilderConstants.BACKGROUND_COLOR + 'dropdown'} />,
        onClick: this._onToggleDropdown.bind(null, PageBuilderConstants.BACKGROUND_COLOR),
        className: this.props.hasContentComponent ? 'disabled' : ''
      },
      {
        name: PageBuilderConstants.INSERT_IMAGES,
        tooltip: I18n.t('insert_image'),
        html: '<span class="ss-picture"></span>',
        onClick: this.props.onInsertImages,
        className: this.props.hasContentComponent ? 'disabled' : ''
      },
      {
        name: PageBuilderConstants.INSERT_FORM,
        tooltip: I18n.t('insert_form'),
        html: '<span class="ss-notice"></span>',
        components: <FormDropdown {...props} ref={PageBuilderConstants.INSERT_FORM + 'dropdown'} onInsertForm={this.props.onInsertForm} />,
        onClick: this._onToggleDropdown.bind(null, PageBuilderConstants.INSERT_FORM),
        className: this.props.hasContentComponent ? 'disabled' : ''
      },
      {
        name: PageBuilderConstants.INSERT_TEXT_VARIABLE,
        tooltip: I18n.t('insert_text_variable'),
        html: '<span class="ss-font"></span>',
        onClick: this.props.onInsertTextVariables,
        className: this.props.hasContentComponent ? 'disabled' : ''
      },
      // {
      //   name: PageBuilderConstants.INSERT_CALENDAR,
      //   tooltip: I18n.t('insert_calendar'),
      //   html: '<span class="ss-calendar"></span>',
      //   components: <CalendarDropdown {...props} ref={PageBuilderConstants.INSERT_CALENDAR + 'dropdown'} onInsertCalendar={this.props.onInsertCalendar} />,
      //   onClick: this._onToggleDropdown.bind(null, PageBuilderConstants.INSERT_CALENDAR)
      // },
      // {
      //   name: PageBuilderConstants.BORDER,
      //   tooltip: I18n.t('border'),
      //   html: '<span class="ss-rules"></span>',
      //   components: <BorderDropdown {...props} ref={PageBuilderConstants.BORDER + 'dropdown'} />,
      //   onClick: this._onToggleDropdown.bind(null, PageBuilderConstants.BORDER)
      // },
      // {
      //   name: PageBuilderConstants.PADDING,
      //   tooltip: I18n.t('padding'),
      //   html: '<span class="ss-rulerpencil"></span>',
      //   components: <PaddingDropdown {...props} ref={PageBuilderConstants.PADDING + 'dropdown'} />,
      //   onClick: this._onToggleDropdown.bind(null, PageBuilderConstants.PADDING)
      // }
    ].map(this.buildButton);

    var editorToolbarClasses = clsx({
      'editor-toolbar': true,
      //disabled: this.props.hasContentComponent
    });

    return (
      <div className="editor-toolbars">
        <div style={this.props.style} className="editor-toolbar-wrapper">
          <div id={this.props.id} className={editorToolbarClasses}></div>
          <div className="editor-custom-toolbar">
            <div ref="buttons" className="btn-group" role="group">
              {buttons}
            </div>
          </div>
        </div>
      </div>
    );
  }

  buildButton(button) {
    return (
      <button type='button' className={'btn btn-dark ' + (button.className ? button.className : '')} onClick={button.onClick} key={button.name} ref={button.name}>
        <b dangerouslySetInnerHTML={{__html: button.html}}></b>
        {button.components ? button.components : null}
        <div className="editor-toolbar-tooltip">{button.tooltip}</div>
      </button>
    );
  }

  /**
  * Removes active class from buttons and hides any associated dropdowns
  */
  deactivateButtons() {
    $(this.refs.buttons).children().each(function () {
      $(this).removeClass('active').find('.editor-dropdown').hide();
    });
  }

  positionTooltips() {
    $(this.refs.buttons).children().each(function () {
      var $button = $(this),
          $tooltip = $button.find('.editor-toolbar-tooltip');

      if ($tooltip.length) {
        $tooltip.css({top: $button.outerHeight() - 2, left: ($button.outerWidth() / 2) - ($tooltip.outerWidth() / 2)});
      }
    });
  }

  _onToggleDropdown(name, event) {
    var self = this,
        $button = $(this.refs[name]),
        dropdown_name = name + 'dropdown',
        $dropdown = $(this.refs[dropdown_name]),
        hide = function () {
          $(window).off('click.' + dropdown_name);
          $dropdown.hide();
          $button.removeClass('active');
          self.positionTooltips();
        };

    // toggle dropdown visibility and set window click handler
    if ($dropdown.is(':visible')) {
      hide();
    } else {
      self.deactivateButtons();
      $button.addClass('active');
      $dropdown.show();
      $(window).on('click.' + dropdown_name, hide);
    }

    event.stopPropagation();
    event.preventDefault();
  }

  shouldComponentUpdate() {
    //console.log('shouldUpdateEditorToolbar', nextProps.mode === PageBuilderConstants.COMPOSE && (nextProps.activeRowId === this.props.rowId && nextProps.activeColumnId === this.props.columnId));
    return nextProps.mode === PageBuilderConstants.COMPOSE && (nextProps.activeRowId === this.props.rowId && nextProps.activeColumnId === this.props.columnId)
  }

};

export default EditorToolbar
